export default () => {
  const $component = $('.brightcove-video-playlist-embed');
  const $componentIframe = $('.brightcove-video-playlist-embed iframe');

  if (!$component) {
    return;
  }

  if ($componentIframe.length) {
    $componentIframe.attr('title', 'ASCE Promo Video');
  }

};